import { useQuery, useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import { App } from "antd";
import * as api from "apis/approval";

//Query untuk get approvals
export function useApprovals({ payload = {} }, options = {}) {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useQuery(
    ["approvals/list", payload],
    async () => {
      let response;
      try {
        const {
          data: { data },
        } = await api.getApprovals(payload);
        response = data;
      } catch (error) {
        throw new Error(t("error.failed_to_load_data_from_server"));
      }
      return response;
    },
    {
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
      ...options,
    }
  );
}

// Query untuk approve approval
export const useApproveApproval = () => {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useMutation((payload) => api.approveApproval(payload), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
    onError: (error) => message.error(t("error.failed_save_data_to_server")),
  });
};

// Query untuk decline approval
export const useDeclineApproval = () => {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useMutation((payload) => api.declineApproval(payload), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
    onError: (error) => message.error(t("error.failed_save_data_to_server")),
  });
};

// Query untuk revert approval
export const useRevertApproval = () => {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useMutation((id) => api.revertApproval(id), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
    onError: (error) => message.error(t("error.failed_save_data_to_server")),
  });
};
